module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 4.99422C13.5304 4.99422 14.0391 5.20493 14.4142 5.58C14.7893 5.95508 15 6.46378 15 6.99422M19 6.99422C19.0003 7.93139 18.781 8.85559 18.3598 9.69276C17.9386 10.5299 17.3271 11.2568 16.5744 11.8151C15.8216 12.3734 14.9486 12.7476 14.0252 12.9077C13.1018 13.0679 12.1538 13.0095 11.257 12.7372L9 14.9942H7V16.9942H5V18.9942H2C1.73478 18.9942 1.48043 18.8889 1.29289 18.7013C1.10536 18.5138 1 18.2594 1 17.9942V15.4082C1.00006 15.143 1.10545 14.8887 1.293 14.7012L7.257 8.73722C7.00745 7.91223 6.93857 7.04316 7.05504 6.18916C7.17152 5.33516 7.47062 4.51629 7.93199 3.78826C8.39336 3.06024 9.00616 2.44016 9.72869 1.97024C10.4512 1.50031 11.2665 1.19157 12.1191 1.06502C12.9716 0.938476 13.8415 0.997099 14.6693 1.2369C15.4972 1.4767 16.2637 1.89205 16.9166 2.45468C17.5696 3.01731 18.0936 3.71401 18.4531 4.49736C18.8127 5.2807 18.9992 6.13231 19 6.99422Z",
      "stroke": "#3F3F46",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7fb25a","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/key.vue
// module id = a345bd8e87e1485d0cf0
// module chunks = 89